import { Period, StatsBreakdown, StatsRange } from '../../enums/reports';

export const dashboardReportRangeOptions: {
    value: StatsRange;
    label: string;
}[] = [
    { value: StatsRange.Today, label: 'Today' },
    { value: StatsRange.Tomorrow, label: 'Tomorrow' },
    { value: StatsRange.CurrentWeek, label: 'This week' },
    { value: StatsRange.PreviousWeek, label: 'Last week' },
    { value: StatsRange.NextWeek, label: 'Next week' },
    { value: StatsRange.CurrentMonth, label: 'This month' },
    { value: StatsRange.CurrentYear, label: 'This year' },
    { value: StatsRange.All, label: 'All time' },
];

export const dashboardReportBreakdownOptions: {
    value: StatsBreakdown;
    label: string;
}[] = [
    { value: StatsBreakdown.Day, label: 'Day' },
    { value: StatsBreakdown.Week, label: 'Week' },
    { value: StatsBreakdown.Month, label: 'Month' },
    { value: StatsBreakdown.Year, label: 'Year' },
    { value: StatsBreakdown.All, label: 'All' },
];

function isPeriod(value: string | null): value is Period {
    return value !== null && Object.values(Period).includes(value as Period);
}

function getStatsRange(period: Period): StatsRange {
    switch (period) {
        case Period.Today:
            return StatsRange.Today;
        case Period.Tomorrow:
            return StatsRange.Tomorrow;
        case Period.CurrentWeek:
            return StatsRange.CurrentWeek;
        case Period.PreviousWeek:
            return StatsRange.PreviousWeek;
        case Period.NextWeek:
            return StatsRange.NextWeek;
        case Period.CurrentMonth:
            return StatsRange.CurrentMonth;
        case Period.CurrentYear:
            return StatsRange.CurrentYear;
        default:
            return StatsRange.CurrentWeek;
    }
}

function getStatsBreakdown(period: Period): StatsBreakdown {
    switch (period) {
        case Period.Today:
        case Period.Tomorrow:
            return StatsBreakdown.Day;
        case Period.CurrentWeek:
        case Period.PreviousWeek:
        case Period.NextWeek:
            return StatsBreakdown.Week;
        case Period.CurrentMonth:
            return StatsBreakdown.Month;
        case Period.CurrentYear:
            return StatsBreakdown.Year;
        default:
            return StatsBreakdown.Month;
    }
}

export function periodToStatsRange(period: Period): StatsRange {
    return getStatsRange(period);
}

export function periodToStatsBreakdown(period: Period): StatsBreakdown {
    return getStatsBreakdown(period);
}

export function statsRangeToStatsBreakdown(range: StatsRange): StatsBreakdown {
    switch (range) {
        case StatsRange.Today:
        case StatsRange.Tomorrow:
            return StatsBreakdown.Day;
        case StatsRange.CurrentWeek:
        case StatsRange.PreviousWeek:
        case StatsRange.NextWeek:
            return StatsBreakdown.Day;
        case StatsRange.CurrentMonth:
            return StatsBreakdown.Week;
        case StatsRange.CurrentYear:
            return StatsBreakdown.Month;
        case StatsRange.All:
            return StatsBreakdown.Year;
        default:
            return StatsBreakdown.Week;
    }
}

export function periodFromSearchParam(
    periodParam: string | null,
    fallback: Period = Period.CurrentYear,
): Period {
    return isPeriod(periodParam) ? periodParam : fallback;
}

export function initialStatsFiltersFromPeriod(period: Period): {
    range: StatsRange;
    breakdown: StatsBreakdown;
} {
    const range = periodToStatsRange(period);

    return {
        range,
        breakdown: statsRangeToStatsBreakdown(range),
    };
}
